const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})
const formatterDollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

export const formatCurrency = (value) => {
  return formatter.format(value)
}

export const formatDollars = (value) => {
  return formatterDollars.format(value)
}
